const FALLBACK_DAYS_IN_BILLING_MONTH = 30

export const formatCurrency = (
  amount: number,
  currencySymbol: string,
  currencyFormat: string,
): string => {
  const formattedAmount = amount.toFixed(2)
  if (currencyFormat === "%n%u") {
    return `${formattedAmount}${currencySymbol}`
  }
  return `${currencySymbol}${formattedAmount}`
}

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return ""
  const date = new Date(dateString)
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  })
}

export const calculateProratedAmount = (
  pricePerSlot: number,
  quantity: number,
  nextBillingDate: string | null | undefined,
  billingPeriodStart: string | null | undefined,
): number => {
  if (!nextBillingDate) {
    return pricePerSlot * quantity
  }

  const now = new Date()
  const billingEnd = new Date(nextBillingDate)

  // Calculate time remaining in milliseconds (matching Stripe's precision)
  const msRemaining = Math.max(0, billingEnd.getTime() - now.getTime())

  // Calculate total billing period length in milliseconds
  let totalPeriodMs: number
  if (billingPeriodStart) {
    const periodStart = new Date(billingPeriodStart)
    totalPeriodMs = billingEnd.getTime() - periodStart.getTime()
  } else {
    // Fallback to 30 days if billing period start is not available
    totalPeriodMs = FALLBACK_DAYS_IN_BILLING_MONTH * 24 * 60 * 60 * 1000
  }

  // Calculate prorated factor based on actual time remaining vs total period
  const proratedFactor = totalPeriodMs > 0 ? msRemaining / totalPeriodMs : 0
  return pricePerSlot * quantity * proratedFactor
}

export const formatCardExpiration = (
  expirationMonth: number | null | undefined,
  expirationYear: string | null | undefined,
): string | null => {
  if (!expirationMonth || !expirationYear) return null
  return `${String(expirationMonth).padStart(2, "0")}/${expirationYear.toString().slice(-2)}`
}
